var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"main-header","role":"banner"}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.$t('meta.title'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }